import Vue from "vue";
import VueRouter from "vue-router";
import cookie from 'vue-cookies'


var indexPage = cookie.get('indexPage');
var redirectUri = indexPage ? '/'+ indexPage : '/login';

//去掉提示
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: redirectUri
  },
  {
    path: "/",
    component: resolve => require(["../views/index.vue"], resolve),
    children: [
      {
        path: "/outgoingLoad",
        component: resolve =>
          require([
            "../views/energyManagement/pvEnergyStorageMonitoring/outgoingLoad.vue"
          ], resolve),
        meta: {
          title: "出线负载",
          p_name: "能源管理"
        }
      },
      {
        path: "/pvEnergyStorageAlarm",
        component: resolve =>
          require([
            "../views/energyManagement/pvEnergyStorageMonitoring/pvEnergyStorageAlarm.vue"
          ], resolve),
        meta: {
          title: "储能报警",
          p_name: "能源管理"
        }
      },
      {
        path: "/pvCurve",
        component: resolve =>
          require([
            "../views/energyManagement/pvEnergyStorageMonitoring/pvCurve.vue"
          ], resolve),
        meta: {
          title: "光伏曲线",
          p_name: "能源管理"
        }
      },
      {
        path: "/pvReport",
        component: resolve =>
          require([
            "../views/energyManagement/pvEnergyStorageMonitoring/pvReport.vue"
          ], resolve),
        meta: {
          title: "光伏报表",
          p_name: "能源管理"
        }
      },
      {
        path: "/energyFlowDiagram",
        component: resolve =>
          require(["../views/pvEnergyStorage/energyFlowDiagram.vue"], resolve),
        meta: {
          title: "能流图",
          p_name: "能源管理"
        }
      },
      {
        path: "/energyCabinetMonitoring",
        component: resolve =>
            require(["../views/energyManagement/pvEnergyStorageMonitoring/energyCabinetMonitoring.vue"], resolve),
        meta: {
          title: "储能柜监控",
          p_name: "能源管理"
        }
      },
      {
        path: "/waterMonitoring",
        component: resolve =>
          require(["../views/realTimeMonitor/waterMonitoring.vue"], resolve),
        meta: {
          title: "水表监测",
          p_name: "给水管理"
        }
      },
      {
        path: "/electricalFireMonitoring",
        component: resolve =>
          require([
            "../views/safetyManagement/fireMonitoring/electricalFireMonitoring"
          ], resolve),
        meta: {
          title: "电气火灾监测",
          p_name: "安防管理"
        }
      },
      {
        path: "/gasMonitoring",
        component: resolve =>
          require([
            "../views/safetyManagement/fireMonitoring/gasMonitoring"
          ], resolve),
        meta: {
          title: "气体监测",
          p_name: "安防管理"
        }
      },
      {
        path: "/flameImageRecognition",
        component: resolve =>
          require([
            "../views/safetyManagement/fireMonitoring/flameImageRecognition"
          ], resolve),
        meta: {
          title: "火焰图像识别",
          p_name: "安防管理"
        }
      },
      {
        path: "/eleRealTimeMonitoring",
          component:resolve =>
            require([
              "../views/powerDistributionManagement/eleRealTimeMonitoring"
            ], resolve),
          meta:{
            title: "实时监测",
            p_name: "配电管理"
        }
      },
      {
        path: "/energyConsumptionAnalysis",
        component: resolve =>
          require(["../views/powerManagement/energyConsumptionAnalysis.vue"], resolve),
        meta: {
          title: "能耗分析",
          p_name: "能耗管理"
        }
        },
      {
        path: "/alarmManagement",
        component: resolve =>
          require(["../views/safetyManagement/alarmManagement.vue"], resolve),
        meta: {
          title: "报警管理",
          p_name: "安防管理"
        }
      },
      {
        path: "/operationRecord",
        component: resolve =>
          require(["../views/safetyManagement/operationRecord.vue"], resolve),
        meta: {
          title: "操作记录",
          p_name: "安防管理"
        }
      },
      {
        path: "/accountManagement",
        component: resolve =>
          require(["../views/safetyManagement/accountManagement.vue"], resolve),
        meta: {
          title: "账号管理",
          p_name: "安防管理"
        }
      },
      {
        path: "/energyConsumptionProfile",
        component: resolve =>
          require(["../views/powerManagement/energyConsumptionProfile.vue"], resolve),
        meta:{
          title: "能耗概况",
          p_name: "能耗管理"
        }
      },
      {
        path: "/accessControlRecord",
        component: resolve =>
          require(["../views/safetyManagement/accessControlRecord.vue"], resolve),
        meta: {
          title: "门禁记录",
          p_name: "安防管理"
        }
      },
      {
        path: "/videoMonitoring",
        component: resolve =>
          require(["../views/safetyManagement/videoMonitoring.vue"], resolve),
        meta: {
          title: "视频监控",
          p_name: "实时监控"
        }
      },
      {
        path: "/towerMonitoring",
        component: resolve =>
          require(["../views/powerTransmissionMonitoring/towerMonitoring.vue"], resolve),
        meta: {
          title: "杆塔监测",
          p_name: "输变电监测"
        }
      },
      {
        path: "/fan3DDisplay",
          component:resolve => require(["../views/energyManagement/fan3D/fanMonitoring.vue"], resolve),
          meta:{
            title: "风机监测",
            p_name:"能源管理"
        }
      },
      {
        path: "/pvEnergyManagement",
        component: resolve =>
          require(["../views/energyManagement/pvEnergyStorageMonitoring/pvEnergyManagement.vue"], resolve),
        meta: {
          title: "能耗管理",
          p_name: "能源管理"
        }
      },
      {
        path: "/rechargePayment",
        component: resolve =>
          require(["../views/estateManagement/rechargePayment/rechargePayment.vue"], resolve),
        meta: {
          title: "充值缴费",
          p_name: "物业管理"
        }
      },
      {
        path: "/paymentHistory",
        component: resolve =>
          require(["../views/estateManagement/rechargePayment/paymentHistory.vue"], resolve),
        meta: {
          title: "缴费历史",
          p_name: "物业管理"
        }
      },
      {
        path: "/merchantBalance",
        component: resolve =>
          require(["../views/estateManagement/rechargePayment/merchantBalance.vue"], resolve),
        meta: {
          title: "商户余额",
          p_name: "物业管理"
        }
      },
      {
        path: "/alarmConfig",
        component: resolve =>
          require(["../views/systemConfig/alarmConfig.vue"], resolve),
        meta: {
          title: "报警配置",
          p_name: "系统配置"
        }
      },
      {
        path: "/electricityReport",
        component: resolve =>
          require(["../views/reportManagement/electricityReport.vue"], resolve),
        meta: {
          title: "用电报表",
          p_name: "配电管理"
        }
      },
      {
        path: "/customerElectricityReport",
        component: resolve =>
          require(["../views/reportManagement/customerElectricityReport.vue"], resolve),
        meta: {
          title: "商户用电报表",
          p_name: "物业管理"
        }
      },
      {
        path: "/customerWaterReport",
        component: resolve =>
          require(["../views/reportManagement/customerWaterReport.vue"], resolve),
        meta: {
          title: "商户用水报表",
          p_name: "物业管理"
        }
      },
      {
        path: "/curveAnalysis",
        component: resolve =>
          require(["../views/powerQuality/curveAnalysis.vue"], resolve),
        meta: {
          title: "曲线分析",
          p_name: "配电管理"
        }
      },
      {
        path: "/energyFlow",
        component: resolve =>
          require(["../views/powerManagement/energyFlow.vue"], resolve),
        meta: {
          title: "能流图",
          p_name: "能效管理"
        }
      },
      {
        path: "/securityVideo",
        component: resolve =>
          require(["../views/safetyManagement/securityVideo.vue"], resolve),
        meta: {
          title: "安防监控",
          p_name: "AI识别"
        }
      },
      {
        path: "/ECCompare",
        component: resolve =>
          require(["../views/powerManagement/buildingECCompare.vue"], resolve),
        meta: {
          title: "能耗对比",
          p_name: "能耗管理"
        }
      },
      {
        path: "/ECRanking",
        component: resolve =>
          require(["../views/powerManagement/ECRanking.vue"], resolve),
        meta: {
          title: "能耗排名",
          p_name: "能耗管理"
        }
      },
      {
        path: "/demandAnalysis",
        component: resolve =>
          require(["../views/powerManagement/needAnalyse.vue"],resolve),
        meta: {
          title: "需量分析",
          p_name: "能耗管理"
        }
      },
      {
        path: "/quotaManagement",
        name: 'quotaManagement',
        component: resolve =>
          require(["../views/powerManagement/quotaManagement.vue"],resolve),
        meta: {
          title: "定额管理",
          p_name: "能耗管理"
        }
      },
      {
        path: "/energyconsumptionassessment",
        name: 'energyconsumptionassessment',
        component: resolve =>
          require(["../views/powerManagement/energyConsumptionAssessment.vue"],resolve),
        meta: {
          title: "能耗考核",
          p_name: "能耗管理"
        }
      },
      {
        path: "/ECTrendAnalysis",
        component: resolve =>
          require(["../views/powerManagement/ECTrendAnalysis.vue"], resolve),
        meta: {
          title: "能耗趋势分析",
          p_name: "能耗管理"
        }
      },
      {
        path: "/companyInfo",
        component: resolve =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "企业简介",
          p_name: "企业推介"
        }
      },
      {
        path: "/page1",
        component: resolve =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "企业简介",
          p_name: "企业推介"
        }
      },{
        path: "/page2",
        component: resolve =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "企业文化",
          p_name: "企业推介"
        }
      },{
        path: "/page3",
        component: resolve =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "发展规划",
          p_name: "企业推介"
        }
      },{
        path: "/page4",
        component: resolve =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "组织结构图",
          p_name: "企业推介"
        }
      },{
        path: "/page5",
        component: resolve =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "人才队伍",
          p_name: "企业推介"
        }
      },{
        path: "/page6",
        component: resolve =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "科技创新",
          p_name: "企业推介"
        }
      },{
        path: "/page7",
        component: resolve =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "主营业务",
          p_name: "企业推介"
        }
      },{
        path: "/page8",
        component: resolve =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "经营规模",
          p_name: "企业推介"
        }
      },{
        path: "/page9",
        component: resolve =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "核心产品",
          p_name: "企业推介"
        }
      },{
        path: "/page10",
        component: resolve =>
          require(["../views/safetyManagement/video/companyInfo.vue"], resolve),
        meta: {
          title: "视频安防",
          p_name: "企业推介"
        }
      },
      {
        path: "/integratedDisplay",
        component: resolve =>
          require(["../views/safetyManagement/video/companyImgList.vue"], resolve),
        meta: {
          title: "企业总览",
          p_name: "企业总览"
        }
      },
      {
        path: "/video3d",           //
        component: resolve =>
          require([
            "../views/safetyManagement/video/video3d.vue"
          ], resolve),
        meta: {
          title: "企业三维",
          p_name: "企业三维"
        }
      },
      {
        path: "/zhuangbei3d",           //
        component: resolve =>
          require([
            "../views/safetyManagement/video/zhuangbei3d.vue"
          ], resolve),
        meta: {
          title: "企业三维",
          p_name: "企业三维"
        }
      },{
        path: "/empty",           //
        component: resolve =>
          require([
            "../views/safetyManagement/video/empty.vue"
          ], resolve),
        meta: {
          title: "企业三维",
          p_name: "企业三维"
        }
      },{
        path: "/nanjing3d",           //
        component: resolve =>
          require([
            "../views/safetyManagement/video/nanjing3d.vue"
          ], resolve),
        meta: {
          title: "企业三维",
          p_name: "企业三维"
        }
      },
    ]
  },
  {
    path: "/GISOverview",
    component: resolve =>
      require([
        "../views/safetyManagement/video/projectOverview.vue"
      ], resolve)
  },
  {
    path: "/pvProfile",
      component: resolve =>
      require(["../views/photovoltaicMonitor/pvProfile.vue"], resolve)
  },
  {
    path: "/conferenceRoom",
      component: resolve =>
      require(["../views/conferenceRoom/conferenceRoom.vue"], resolve)
  },
  {
    path: "/eleDistributionRoom",
    component: resolve =>
        require(["../views/eleDistributionRoom/eleDistributionRoom.vue"], resolve)
  },
  {
    path: "/login",
    component: resolve => require(["../views/login.vue"], resolve)
  },
  {
    path: "/generalSituation",
    component: resolve => require(["../views/generalSituation.vue"], resolve)
  },
  {
    name: 'printFirePic',
    path: "/printFirePic",
    component: resolve => require(["../views/safetyManagement/fireMonitoring/printFirePic.vue"], resolve)
  },
  {
    name: 'printAlarm',
    path: "/printAlarm",
    component: resolve => require(["../views/safetyManagement/printAlarm"],resolve)
  },
  {
    name: "reportTablePrint",
    path: "/reportTablePrint",
    component: resolve =>
      require(["../views/reportManagement/reportTablePrint.vue"], resolve)
  },
  {
    name: "customerElectricityReportPrint",
    path: "/customerElectricityReportPrint",
    component: resolve =>
      require(["../views/reportManagement/customerElectricityReportPrint.vue"], resolve)
  },
  {
    path: "/eleDistributionRoom1",
    component: resolve =>
      require(["../views/eleDistributionRoom/eleDistributionRoom1.vue"], resolve)
  },
  {
    name: 'printECRanking',
    path: "/printECRanking",
    component: resolve => require(["../views/powerManagement/printECRanking"],resolve)
  },
  {
    path: "/index",
    component: resolve =>
      require(["../views/tempIndex.vue"], resolve)
  },
];
/*var redirectCon = null;
for(let i = 0;i< routes.length;i++){
  let tempData = routes[i];
  if(!tempData.children){
    //全屏页面
    let firstLevel = tempData.path;
    if(firstLevel == redirectUri){
      redirectCon = tempData.component
    }
  }else{
    //有左侧菜单的页面
    let childrenPageArr = tempData.children;
    for(let i in childrenPageArr){
      let childPage = childrenPageArr[i];
      let childPagePath = childPage.path;
      if(childPagePath == redirectUri){
        redirectCon = childPage.component
      }
    }
  }
}*/
routes.push({
  path: '*',
  redirect: redirectUri
})

const router = new VueRouter({
  routes
});

export default router;
